import LoadingIndicator from './loadingIndicator';
import React from 'react';

export function Loading({ label, ...props }) {
    return (
        <div {...props} className={props.className}>
            <LoadingIndicator />
            {label}
        </div>
    );
}

export const loadingValue = (value, { check = value, className, label } = {}) => {
    const result = check instanceof Function ? check() : check;
    if (!result) {
        return <Loading className={className} label={label} />;
    }
    return value;
};
